export function getLastStepId(config) {
    return Math.max(...config.steps.map((step) => step.id));
}
export function resolveNextTouchPoint(config, lastShownStep, elapsedDays) {
    let best;
    for (const step of config.steps) {
        const eligible = lastShownStep < step.id &&
            elapsedDays >= step.minElapsedDays &&
            (step.maxElapsedDays === undefined || elapsedDays <= step.maxElapsedDays);
        if (eligible && (best === undefined || step.id > best.id)) {
            best = step;
        }
    }
    return best;
}
export function getStepById(config, step) {
    return config.steps.find((s) => s.id === step);
}
